<script setup lang="ts"></script>
<template>
    <svg
        width="512px"
        height="512px"
        viewBox="0 0 512 512"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <title>Sicher-Teilen</title>
        <g
            id="Thumbnail/Transparent-BG"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
        >
            <g
                id="FavIcon/Primary-Clr-BG/512x512-(Android)_Primary-Clr-BG"
                fill="#D63E2D"
                fill-rule="nonzero"
            >
                <g
                    id="Brand/Signet/Brandsignet-Color"
                    transform="translate(34, 63.7424)"
                >
                    <g
                        id="regular/24/horse-head"
                        transform="translate(134.5875, 84.4291)"
                    >
                        <path
                            id="solid/20/lock-keyhole"
                            d="M87.4125005,24.9750001 C104.66086,24.9750001 118.631251,38.9453908 118.631251,56.1937503 L118.631251,74.9250004 L56.1937503,74.9250004 L56.1937503,56.1937503 C56.1937503,38.9453908 70.164141,24.9750001 87.4125005,24.9750001 Z M31.2187502,56.1937503 L31.2187502,74.9250004 L24.9750001,74.9250004 C11.1997266,74.9250004 0,86.124727 0,99.9000006 L0,174.825001 C0,188.600274 11.1997266,199.800001 24.9750001,199.800001 L149.850001,199.800001 C163.625274,199.800001 174.825001,188.600274 174.825001,174.825001 L174.825001,99.9000006 C174.825001,86.124727 163.625274,74.9250004 149.850001,74.9250004 L143.606251,74.9250004 L143.606251,56.1937503 C143.606251,25.1701173 118.436133,-1.42108547e-14 87.4125005,-1.42108547e-14 C56.3888675,-1.42108547e-14 31.2187502,25.1701173 31.2187502,56.1937503 Z M99.9000006,124.875001 L99.9000006,149.850001 C99.9000006,156.757149 94.319649,162.337501 87.4125005,162.337501 C80.505352,162.337501 74.9250004,156.757149 74.9250004,149.850001 L74.9250004,124.875001 C74.9250004,117.967852 80.505352,112.387501 87.4125005,112.387501 C94.319649,112.387501 99.9000006,117.967852 99.9000006,124.875001 Z"
                        ></path>
                    </g>
                    <path
                        id="Polygon"
                        d="M222,-29.7423604 L414.25764,81.2576396 L414.25764,303.25764 L222,414.25764 L29.7423604,303.25764 L29.7423604,81.2576396 L222,-29.7423604 Z M222,6.87971107 L61.4543571,99.5647111 L61.4543571,284.94264 L222,377.62764 L382.537714,284.94264 L382.537714,99.5647111 L222,6.87971107 Z"
                        transform="translate(222, 192.2576) rotate(90) translate(-222, -192.2576)"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
</template>
